import { render } from "./ColumnCharts.vue?vue&type=template&id=6fa298d2"
import script from "./ColumnCharts.vue?vue&type=script&lang=js"
export * from "./ColumnCharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__